import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import chat from '~/components/chat.vue';
import isButton from '~/components/button.vue';
import FormData from 'form-data';
import socket from '~/plugins/socket.io.js';
import API from '~/api/api.js';
import upload from '~/components/upload.vue';
export default {
  props: ['roomName', 'datas', 'title', 'cls', 'type', 'persons'],
  data: function data() {
    this.scrollToBottom();
    return {
      progressLevel: '0',
      message: '',
      style: {
        padding: '1rem',
        display: 'none'
      },
      messages: this.datas
    };
  },

  components: {
    chat: chat,
    isButton: isButton,
    upload: upload
  },
  watch: {
    // messages: 'scrollToBottom'
  },

  beforeMount: function beforeMount() {
    var _this = this;

    socket.on('new-message', function (message) {
      if (message.roomName === _this.roomName) {
        _this.messages.push(message);
        _this.scrollToBottom();
      }
      _this.$store.dispatch('loadComment');
    });
  },

  methods: {
    onProgress: function onProgress(percent) {
      this.progressLevel = percent + '';
      // console.log(this.progressLevel)
    },
    sendFile: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var items, button, upload, formData, type, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, response, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _file, fileMessage;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                items = this.$refs.upload.getItems();
                button = this.$refs.btnCreate;
                upload = this.$refs.upload;
                formData = new FormData(); // Currently empty

                type = this.type === undefined || this.type === '' ? 'project' : 'prodTask';

                formData.append('type', type);
                formData.append('id', this.roomName);
                _context.next = 9;
                return API.setToken(this.$store.state.authUser.tokenID);

              case 9:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 12;

                for (_iterator = _getIterator(items); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  file = _step.value;

                  formData.append('fileUpload', file.file, file.file.name);
                }
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](12);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 20:
                _context.prev = 20;
                _context.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context.prev = 23;

                if (!_didIteratorError) {
                  _context.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context.finish(23);

              case 27:
                return _context.finish(20);

              case 28:
                _context.next = 30;
                return API.uploadChat(formData, this.onProgress);

              case 30:
                response = _context.sent;

                if (!response.data.flag) {
                  _context.next = 59;
                  break;
                }

                // console.log(response.data.datas)
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 35;
                _iterator2 = _getIterator(response.data.datas);

              case 37:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 45;
                  break;
                }

                _file = _step2.value;
                fileMessage = '<i class="fa fa-paperclip"></i> <a target="_blank" href="' + _file.filePath + '">' + _file.fileName + '</a>';
                _context.next = 42;
                return this.send(fileMessage, 'file');

              case 42:
                _iteratorNormalCompletion2 = true;
                _context.next = 37;
                break;

              case 45:
                _context.next = 51;
                break;

              case 47:
                _context.prev = 47;
                _context.t1 = _context['catch'](35);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 51:
                _context.prev = 51;
                _context.prev = 52;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 54:
                _context.prev = 54;

                if (!_didIteratorError2) {
                  _context.next = 57;
                  break;
                }

                throw _iteratorError2;

              case 57:
                return _context.finish(54);

              case 58:
                return _context.finish(51);

              case 59:

                button.enabled();
                upload.reset();

              case 61:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[12, 16, 20, 28], [21,, 23, 27], [35, 47, 51, 59], [52,, 54, 58]]);
      }));

      function sendFile() {
        return _ref.apply(this, arguments);
      }

      return sendFile;
    }(),
    scrollToBottom: function scrollToBottom() {
      var _this2 = this;

      this.$nextTick(function () {
        try {
          _this2.$refs.messages.scrollTop = _this2.$refs.messages.scrollHeight;
        } catch (e) {}
      });
    },
    toggleUpload: function toggleUpload() {
      if (this.style.display === 'none') {
        this.style.display = 'block';
      } else {
        this.style.display = 'none';
      }
    },
    sendMessage: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.send(this.message.trim(), 'text');
                // this.$store.dispatch('loadComment')

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendMessage() {
        return _ref2.apply(this, arguments);
      }

      return sendMessage;
    }(),
    send: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(text, type) {
        var autUser, now, message;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                autUser = this.$store.state.authUser;
                now = moment();
                message = {
                  date: now.format(),
                  userID: this.$store.state.authUser.userID,
                  userName: autUser.firstName,
                  firstName: autUser.firstName,
                  roleID: this.$store.state.authUser.roleID,
                  token: this.$store.state.authUser.tokenID,
                  roomName: this.roomName,
                  type: type,
                  // demo: autUser,
                  text: text
                  // con

                };
                this.messages.push(message);

                this.message = '';
                _context3.next = 7;
                return API.setToken(this.$store.state.authUser.tokenID);

              case 7:
                _context3.next = 9;
                return API.sendMessage(message);

              case 9:
                socket.emit('send-message', message);
                this.scrollToBottom();

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function send(_x, _x2) {
        return _ref3.apply(this, arguments);
      }

      return send;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/chat-full-box.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/chat-full-box.vue
// module chunks = 0 1 2 3 4